export function jiraTicketIDExtractor(ticketIdOrLink: string): string | null {
  const urlPattern = /^https?:\/\//;

  if (urlPattern.test(ticketIdOrLink)) {
    const match = ticketIdOrLink.match(/\/browse\/([^/?#]+)/);
    if (!match) {
      return null;
    }
    return match[1];
  } else {
    return ticketIdOrLink;
  }
}
